<template>
  <v-card elevation="0" class="wrapper">
    <h1 v-if="$vuetify.breakpoint.mdAndUp">
      {{ slug && slug.title ? slug.title : '' }}
    </h1>
    <v-row v-else>
      <v-col cols="10">
        <h1 class="title-preview">
          {{ slug && slug.title ? slug.title : '' }}
        </h1>
      </v-col>
      <v-col cols="2" class="d-flex justify-end mb-2">
        <v-btn @click="$emit('open')" elevation="0">
          <v-icon color="#ee8e51">
            mdi-tag-outline
          </v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <slot></slot>
    <div v-html="slug && slug.body ? slug.body : ''"></div>
  </v-card>
</template>

<script>
export default {
  name: 'SlugContentComponent',
  props: {
    slug: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style lang="scss" scoped>
h1 {
  font-size: 18px !important;
  font-weight: 700;
  margin-bottom: 16px;
}

.theme--light {
  &.v-btn.v-btn--has-bg {
    background-color: transparent !important;
    border: 1px solid #ee8e51;

    width: 44px !important;
    min-width: 44px !important;
    height: 44px !important;
  }
}
</style>
